import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const Payment = () => {
  const location = useLocation();
  const { cartItems, formData } = location.state || {};

  const [loading, setLoading] = useState(false); // To show loading state while creating the order

  const totalCost = cartItems.reduce((total, item) => {
    const price = parseFloat(item.price.replace(/[^0-9.-]+/g, ""));
    return total + (isNaN(price) ? 0 : price);
  }, 0).toFixed(2);

  
  const createOrder = async () => {
    setLoading(true); // Set loading to true when initiating the order creation
    try {
      const response = await fetch('https://backend-matihaat.onrender.com/api/payment/create-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: totalCost * 100 }) // amount in paisa
      });
      const data = await response.json();
      if (data.success) {
        setLoading(false); // Reset loading state once the order is created
        initializeRazorpay(data.order_id); // Pass order_id to Razorpay
      } else {
        console.error("Failed to create order:", data.message);
        setLoading(false); // Reset loading in case of failure
      }
    } catch (error) {
      console.error("Error in order creation:", error);
      setLoading(false); // Reset loading in case of error
    }
  };

  const initializeRazorpay = (order_id) => {
    console.log("Initializing Razorpay with order_id:", order_id); // Check if this logs
    const options = {
      key: 'rzp_live_H506WObJ3omCIz', // Your Razorpay key
      amount: totalCost * 100, // amount in paisa
      currency: 'INR',
      name: 'Your Store',
      description: 'Order Payment',
      order_id,
      handler: async (response) => {
        console.log("Payment handler response:", response); // Log the response here
        const verifyPayload = {
          order_id,
          payment_id: response.razorpay_payment_id,
          signature: response.razorpay_signature,
          formData,
          cartItems
        };
  
        try {
          const verifyRes = await fetch('https://backend-matihaat.onrender.com/api/payment/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(verifyPayload)
          });
          const verifyData = await verifyRes.json();
          if (verifyData.success) {
            alert("✅ Payment successful & order placed!");
          } else {
            alert("❌ Payment verification failed");
          }
        } catch (err) {
          console.error("Verification error:", err);
        }
      },
      prefill: {
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        contact: formData.phone,
      },
      theme: {
        color: '#F37254',
      },
    };
  
    // Ensure that Razorpay modal opens
    const paymentObject = new window.Razorpay(options);
    try {
      paymentObject.open();
      console.log("Razorpay modal opened successfully"); // Confirm modal is opening
    } catch (err) {
      console.error("Error opening Razorpay modal:", err);
    }
  };
  

  useEffect(() => {
    const loadRazorpayScript = () => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => console.log('Razorpay script loaded successfully'); // Log when script is loaded
      script.onerror = () => console.error('Failed to load Razorpay script');
      document.body.appendChild(script);
    };

    if (cartItems?.length && formData?.email) {
      loadRazorpayScript(); // Load Razorpay script only when cart and form data are present
    }
  }, [formData, cartItems]);

  return (
    <Container className="mt-5">
      <Row>
        <Col md={8}>
          <h3>Payment Details</h3>

          <h4>Shipping Address</h4>
          <Table bordered striped hover>
            <tbody>
              <tr>
                <td><strong>Full Name</strong></td>
                <td>{formData.firstName} {formData.lastName}</td>
              </tr>
              <tr>
                <td><strong>Street Address</strong></td>
                <td>{formData.streetAddress}{formData.apartment && `, ${formData.apartment}`}</td>
              </tr>
              <tr>
                <td><strong>Town / City</strong></td>
                <td>{formData.town}</td>
              </tr>
              <tr>
                <td><strong>State</strong></td>
                <td>{formData.state}</td>
              </tr>
              <tr>
                <td><strong>Postcode</strong></td>
                <td>{formData.postcode}</td>
              </tr>
              <tr>
                <td><strong>Phone</strong></td>
                <td>{formData.phone}</td>
              </tr>
              <tr>
                <td><strong>Email</strong></td>
                <td>{formData.email}</td>
              </tr>
            </tbody>
          </Table>
        </Col>

        <Col md={4}>
          <h4>Order Summary</h4>
          <Table bordered striped hover>
            <thead>
              <tr>
                <th>Product</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item, index) => (
                <tr key={index}>
                  <td>
                    <img src={item.img} alt={item.name} style={{ width: 50, height: 50, objectFit: 'cover' }} />
                    <span className="ms-3">{item.name}</span>
                  </td>
                  <td>{item.price}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>₹{totalCost}</strong></td>
              </tr>
            </tbody>
          </Table>

          <Button
            variant="success"
            className="w-100 mt-4"
            onClick={createOrder} // Trigger Razorpay checkout on click
            disabled={loading || !cartItems?.length || !formData?.email} // Disable if loading or required data is missing
          >
            {loading ? 'Processing Payment...' : 'Pay Now'}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Payment;
